const getNestedPosition = (groupIndex, count, nestedIndex, childCount, isVertical) => {
    const isFirstGroup = groupIndex === 0;
    const isLastGroup = groupIndex === count - 1;
    const isFirstNested = nestedIndex === 0;
    const isLastNested = nestedIndex === childCount - 1;
    if (!isFirstGroup && !isLastGroup)
        return 'middle';
    if (isFirstGroup && isFirstNested && isVertical)
        return 'start';
    if (isLastGroup && isLastNested && isVertical)
        return 'end';
    if (isFirstGroup && isFirstNested && !isVertical)
        return 'nested-top-start';
    if (isFirstNested && !isVertical)
        return 'nested-bottom-start';
    if (isLastNested && !isVertical) {
        return isFirstGroup ? 'nested-top-end' : 'nested-bottom-end';
    }
    return 'middle';
};
const getPositionInGroup = (index, count) => {
    if (index === 0)
        return 'start';
    if (index === count - 1)
        return 'end';
    return 'middle';
};

export { getNestedPosition, getPositionInGroup };
//# sourceMappingURL=controlGrout.js.map
